import { Box, Modal } from '@palmetto/palmetto-components';
import { DateTime } from 'luxon';

import { AccountDocument, FundEvent, TrancheStatus } from 'types';

interface TrancheHistoryModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  account: AccountDocument | null;
}

const fundEventLabels: Partial<Record<FundEvent, string>> = {
  [FundEvent.addAccount]: 'Add Account',
  [FundEvent.reassignAccount]: 'Reassign Account',
  [FundEvent.removeAccount]: 'Remove Account',
  [FundEvent.trancheClosed]: 'Tranche Closed',
};

const trancheStatusLabels: Record<TrancheStatus, string> = {
  [TrancheStatus.open]: 'Open',
  [TrancheStatus.closed]: 'Closed',
};

export function TrancheHistoryModal({ isOpen, onDismiss, account }: TrancheHistoryModalProps) {
  const trancheHistory = account?.trancheHistory || [];

  return (
    <Modal ariaLabelledBy="trancheHistoryModal" isOpen={isOpen} onDismiss={onDismiss} maxWidth="700px">
      <Modal.Header
        id="trancheHistoryModal"
        title={
          (
            <Box>
              <Box>Tranche History ({trancheHistory.length})</Box>
              <Box fontSize="xs" fontWeight="regular" color="grey-500" margin="xs 0 0 0">
                Tranche history only goes back to 11/23/2025
              </Box>
            </Box>
          ) as any
        }
        onDismiss={onDismiss}
      />
      <Modal.Body childGap="lg" background="secondary">
        {trancheHistory.length === 0 ? (
          <Box padding="lg" textAlign="center" color="grey-500">
            No tranche history available
          </Box>
        ) : (
          trancheHistory.map((entry, index) => (
            <Box key={`${entry.trancheName}-${entry.event}-${entry.date?.toString()}-${index}`}>
              <Box childGap="sm">
                <Box color="grey-500" fontSize="md" fontWeight="bold">
                  Event {index + 1}: {fundEventLabels[entry.event] || entry.event}
                </Box>
                <Box padding="0 0 0 md">
                  <Box fontSize="sm" margin="0 0 xs 0">
                    <Box fontWeight="bold" display="inline">
                      Tranche:{' '}
                    </Box>
                    {entry.trancheName}
                  </Box>
                  <Box fontSize="sm" margin="0 0 sm 0">
                    <Box fontWeight="bold" display="inline">
                      Status:{' '}
                    </Box>
                    {trancheStatusLabels[entry.trancheStatus] || entry.trancheStatus}
                  </Box>

                  <Box display="flex" gap="md" fontSize="sm">
                    <Box>
                      <Box fontWeight="bold" color="grey-500" fontSize="sm" margin="0 0 2xs 0">
                        Date:
                      </Box>
                      <Box color="grey-800">
                        {entry.date
                          ? (typeof entry.date === 'string'
                              ? DateTime.fromISO(entry.date).toLocal()
                              : DateTime.fromJSDate(entry.date)
                            ).toFormat('MMM dd, yyyy h:mm a')
                          : '---'}
                      </Box>
                    </Box>
                    <Box>
                      <Box fontWeight="bold" color="grey-500" fontSize="sm" margin="0 0 2xs 0">
                        User:
                      </Box>
                      <Box color="grey-800">{entry.user || 'system'}</Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {index < trancheHistory.length - 1 && <Box height="1px" background="grey-200" margin="lg 0" />}
            </Box>
          ))
        )}
      </Modal.Body>
    </Modal>
  );
}
